import React, { useState } from 'react'
import { Input, Tag, Form, Button } from 'antd'
const { TextArea } = Input

const MyForm = () => {
  const [inputValue, setInputValue] = useState('')
  const [result, setResult] = useState(0)
  const handleChange = e => {
    setInputValue(e)
    let str = e.target.value
    str = str.replace(/[ ]|[\r\n]/g, '')
    setResult(str.length)
    console.log(str)
  }

  const count = () => {
    if (inputValue) {
      setResult(inputValue.target.value.length)
    }
  }

  return (
    <Form
      labelCol={{
        span: 4
      }}
      wrapperCol={{
        span: 16
      }}
    >
      <Form.Item name="input" label="文字">
        <TextArea
          rows={12}
          placeholder="请输入要统计的文本"
          value={inputValue}
          onChange={handleChange}
        />
      </Form.Item>
      <Form.Item
        name="submit"
        wrapperCol={{
          offset: 10,
          span: 4
        }}
      >
        <Button type="primary" onClick={count}>
          字数统计
        </Button>
      </Form.Item>
      {result > 0 ? (
        <Form.Item name="count">
          <Tag color="success">{result}</Tag>
        </Form.Item>
      ) : (
        ''
      )}
    </Form>
  )
}

export default MyForm
